import { render, staticRenderFns } from "./fsyd.vue?vue&type=template&id=467cc678&scoped=true&"
import script from "./fsyd.vue?vue&type=script&lang=js&"
export * from "./fsyd.vue?vue&type=script&lang=js&"
import style0 from "./fsyd.vue?vue&type=style&index=0&id=467cc678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467cc678",
  null
  
)

export default component.exports